module.exports = __webpack_public_path__ + "static/media/user-frame-33_1.5f610ff3.svg";